import { pedir } from '../store/api';
import { getDeviceId } from '../store/session';

/**
 * «Está enfocando», para el círculo. El servidor decide si se publica según la
 * casilla de compartir presencia; aquí solo se avisa, y solo con cuenta.
 *
 * Es fuego y olvido: sin red o sin sesión no pasa nada, y el foco funciona igual.
 * `sync` se importa al vuelo para no meterlo en el camino crítico del arranque.
 */
export function avisarPresencia(estado: 'enfocando' | 'disponible', minutos?: number): void {
  void (async () => {
    try {
      const { cuentaVinculada } = await import('../store/sync');
      if (!(await cuentaVinculada())) return;
      await pedir('/social/presencia', {
        deviceId: getDeviceId(),
        metodo: 'POST',
        cuerpo: minutos === undefined ? { estado } : { estado, minutos },
      });
    } catch {
      // Silencio a propósito: la presencia es un adorno, no un dato.
    }
  })();
}
